import type { Room } from "building-types/rooms/roomTypes";
import type { Table } from "common/data/table";

export function roomsInBlock(blockId: string, rooms: Table<Room>): Room[] {
  let blockRooms: Room[] = [];
  for (const r in rooms) {
    if (rooms[r].parentId === blockId) {
      blockRooms = [...blockRooms, rooms[r]];
    }
  }
  return blockRooms;
}
